import React from 'react';
import {
  Users,
  Globe,
  Smartphone,
  Layout,
  Palette,
  ArrowRight,
  Check
} from 'lucide-react';
import { Button } from '@/components/ui/button';

const aiFeatures = [
  'Instant generation',
  'Premium dark layouts',
  'Conversion-focused architecture',
  'Quick iteration & launch',
];

const customServices = [
  { icon: Globe, title: 'Web Development', desc: 'Custom enterprise-grade sites tailored to you.' },
  { icon: Smartphone, title: 'App Development', desc: 'Native IOS and Android applications.' },
  { icon: Layout, title: 'Landing Pages', desc: 'High conversion single page sites.' },
  { icon: Palette, title: 'UI/UX Design', desc: 'World-class interactive interface design.' },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 md:py-32 relative overflow-hidden bg-zinc-950 border-t border-white/5">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div
         
         
         
          className="text-center mb-20"
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 mb-6">
            <span className="text-sm font-semibold text-primary uppercase tracking-[0.2em]">Our Services</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight">
            Two paths to your <span className="text-gradient">digital presence</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          
          {/* AI Builder Service (Bento Style) */}
          <div
           
           
           
           
            className="lg:col-span-5 relative group h-full"
          >
            {/* Animated Gradient Border effect */}
            <div className="absolute -inset-[1px] bg-gradient-to-b from-primary/50 to-primary/0 rounded-[2.5rem] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            <div className="relative h-full bg-zinc-900/60 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-10 flex flex-col items-start overflow-hidden hover:bg-zinc-900/80 transition-colors">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[radial-gradient(ellipse_at_center,hsl(var(--primary)/0.1)_0%,transparent_70%)] -translate-y-1/2 translate-x-1/2 pointer-events-none" />
              
              <div className="w-16 h-16 rounded-2xl bg-primary/20 border border-primary/30 flex items-center justify-center mb-8 relative z-10">
                
              </div>
              
              <h3 className="text-3xl font-bold text-white mb-4">
                AI Builder Access
              </h3>
              
              <p className="text-zinc-400 mb-8 leading-relaxed">
                Let our proprietary AI construct your website in minutes. Simply describe the vision, and watch advanced logic compile your interface.
              </p>

              <ul className="space-y-4 mb-10 w-full mt-auto">
                {aiFeatures.map((feature, i) => (
                  <li 
                    key={feature} 
                   
                   
                   
                    className="flex items-center gap-4 text-zinc-300"
                  >
                    <div className="w-6 h-6 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center shrink-0">
                      <Check className="w-3.5 h-3.5 text-primary" />
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>

              <Button 
                className="w-full bg-white text-zinc-950 hover:bg-zinc-200 h-14 font-bold rounded-2xl text-lg group-hover:shadow-[0_0_30px_rgba(255,255,255,0.15)] transition-all"
              >
                Launch Builder
                <ArrowRight className="ml-2 w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>

          {/* Done-For-You Service (Bento Box Grid) */}
          <div
           
           
           
           
            className="lg:col-span-7 flex flex-col gap-6"
          >
            {/* Header Box */}
            <div className="bg-zinc-900/40 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-10 relative overflow-hidden flex items-center justify-between group cursor-default">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="relative z-10 max-w-lg">
                <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex items-center justify-center mb-6">
                  <Users className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-3xl font-bold text-white mb-3 tracking-tight">
                  Done-For-You Studio
                </h3>
                <p className="text-zinc-400">
                  Share your vision, we execute everything. High-touch bespoke development by our elite engineering unit.
                </p>
              </div>
              <Button variant="ghost" className="hidden sm:flex self-end mb-2 h-14 w-14 rounded-full bg-white/5 border border-white/10 text-white hover:bg-white/10 p-0 flex-shrink-0">
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </Button>
            </div>

            {/* Grid of 4 specific services */}
            <div className="grid sm:grid-cols-2 gap-6 h-full">
              {customServices.map((service, index) => (
                <div 
                  key={service.title}
                 
                 
                 
                  className="bg-zinc-900/40 backdrop-blur-xl border border-white/10 rounded-[2rem] p-8 group hover:bg-zinc-900/80 hover:border-white/20 transition-all cursor-default"
                >
                  <service.icon className="w-8 h-8 text-zinc-400 group-hover:text-primary transition-colors mb-5" />
                  <h4 className="text-xl font-bold text-white mb-2">{service.title}</h4>
                  <p className="text-zinc-500 text-sm leading-relaxed">{service.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}